import { useState } from 'react'
import { Database, Loader2, AlertCircle, ChevronDown } from 'lucide-react'

// Sunucu rolünde ilk açılış: kurulu PostgreSQL'e bağlanıp veritabanı + şema kurar.
// postgres süper kullanıcısının şifresini ister; gerisini uygulama otomatik yapar.
export default function DbSetupWizard({ onDone }: { onDone: () => void }) {
  const [sifre, setSifre] = useState('')
  const [host, setHost] = useState('localhost')
  const [port, setPort] = useState('5432')
  const [gelismis, setGelismis] = useState(false)
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState<string | null>(null)

  async function handleKur() {
    if (!sifre) { setError('PostgreSQL (postgres) şifresini girin'); return }
    setLoading(true)
    setError(null)
    try {
      const { invoke } = await import('@tauri-apps/api/core')
      await invoke('setup_database', {
        postgresPassword: sifre,
        host: host || 'localhost',
        port: port ? Number(port) : 5432,
      })
      onDone()
    } catch (e: unknown) {
      setError(typeof e === 'string' ? e : (e instanceof Error ? e.message : 'Veritabanı kurulumu başarısız'))
    } finally {
      setLoading(false)
    }
  }

  return (
    <div className="min-h-screen bg-bg-base flex items-center justify-center p-4">
      <div className="w-full max-w-md">
        <div className="text-center mb-8">
          <div className="w-16 h-16 rounded-2xl bg-primary flex items-center justify-center mx-auto mb-4">
            <Database className="w-8 h-8 text-white" />
          </div>
          <h1 className="text-2xl font-bold text-text-primary">Veritabanı Kurulumu</h1>
          <p className="text-sm text-text-secondary mt-1">İlk kurulum için PostgreSQL bağlantı bilgisi</p>
        </div>

        <div className="bg-bg-surface rounded-xl border border-bg-border p-6 shadow-sm space-y-4">
          <p className="text-xs text-text-secondary bg-bg-elevated rounded-lg p-3 leading-relaxed">
            PostgreSQL'in kurulu ve çalışıyor olması gerekir. Kurulum sırasında belirlediğiniz
            <strong> postgres</strong> kullanıcısının şifresini girin; veritabanı, tablolar ve
            yönetici hesabı otomatik oluşturulacaktır.
          </p>

          <div>
            <div className="text-sm font-medium text-text-secondary mb-1.5">postgres Şifresi *</div>
            <input
              type="password"
              value={sifre}
              onChange={(e) => setSifre(e.target.value)}
              placeholder="PostgreSQL kurulumunda belirlediğiniz şifre"
              className="w-full px-3 py-2.5 text-sm rounded-lg border border-bg-border bg-bg-base text-text-primary placeholder:text-text-muted focus:outline-none focus:ring-2 focus:ring-primary/30 focus:border-primary"
              onKeyDown={(e) => e.key === 'Enter' && handleKur()}
            />
          </div>

          <button
            type="button"
            onClick={() => setGelismis((v) => !v)}
            className="flex items-center gap-1 text-xs text-text-muted hover:text-text-secondary"
          >
            <ChevronDown className={`w-3.5 h-3.5 transition-transform ${gelismis ? 'rotate-180' : ''}`} />
            Gelişmiş (sunucu / port)
          </button>
          {gelismis && (
            <div className="grid grid-cols-2 gap-3">
              <div>
                <div className="text-xs text-text-muted mb-1">Sunucu</div>
                <input value={host} onChange={(e) => setHost(e.target.value)} className="w-full px-3 py-2 text-sm rounded-lg border border-bg-border bg-bg-base text-text-primary focus:outline-none focus:ring-2 focus:ring-primary/30" />
              </div>
              <div>
                <div className="text-xs text-text-muted mb-1">Port</div>
                <input value={port} onChange={(e) => setPort(e.target.value)} className="w-full px-3 py-2 text-sm rounded-lg border border-bg-border bg-bg-base text-text-primary focus:outline-none focus:ring-2 focus:ring-primary/30" />
              </div>
            </div>
          )}

          {error && (
            <div className="flex items-start gap-2 text-sm text-error bg-error/10 px-3 py-2 rounded-lg">
              <AlertCircle className="w-4 h-4 flex-shrink-0 mt-0.5" />
              <span className="break-words">{error}</span>
            </div>
          )}

          <button
            onClick={handleKur}
            disabled={loading}
            className="w-full flex items-center justify-center gap-2 py-2.5 rounded-lg bg-primary text-white text-sm font-medium hover:bg-primary/90 disabled:opacity-50 transition-colors"
          >
            {loading ? <><Loader2 className="w-4 h-4 animate-spin" />Kuruluyor...</> : 'Veritabanını Kur'}
          </button>
        </div>
      </div>
    </div>
  )
}
